import { format } from 'date-fns';

export default {
  methods: {
    generatePartnerTypesDataSources(isActive = false) {
      let dataSources = [];
      let partnerTypes = Object.values(this.$store.state.entities.partnerTypes);
      if (Array.isArray(partnerTypes)) {
        partnerTypes = partnerTypes.sort((a, b) => {
          return b.titlePlural > a.titlePlural ? -1 : 1;
        }).sort((a, b) => {
          a = a.order ? a.order : 0;
          b = b.order ? b.order : 0;
          return b - a;
        })
        for (let type of partnerTypes) {
          dataSources.push({
            name: type.titlePlural,
            parentId: type._id,
            get: {
              url: process.env.API_BASE_URL + "/map-features",
              method: "get",
              params: {
                q: JSON.stringify({
                  partnerTypes: type._id
                }),
                limit: 0
              },
              toGeoJson: data => {
                return {
                  type: "FeatureCollection",
                  features: data.results.map(item => {
                    let feature = item.feature;
                    feature.properties.id = item._id;
                    feature.properties.parentData = {
                      title: item.partner.name,
                      url: `https://global.rescue-1.co.il/partners/${item.partner._id}`
                    }
                    return feature;
                  })
                };
              }
            },
            editable: false,
            overrideProperties: {
              markerType: "",
              glyph: type.icon,
              iconColor: "white",
              color: type.color
            },
            defaultProperties: {
              markerType: "",
              iconColor: "white",
              color: "blue"
            },
            isActive
          });
        }
      }
      this.$store.commit("maps/APPEND_DATA_SOURCES_GROUPS", {
        mapId: this.mapId,
        val: [
          {
            title: "ספקים",
            dataSources
          }
        ]
      });
    },
    generateEventsDataSources(isActive = false) {
      let dataSources = [];
      let eventTypes = Object.values(this.$store.state.entities.eventTypes);
      if (Array.isArray(eventTypes)) {
        for (let type of eventTypes) {
          dataSources.push({
            name: type.titlePlural,
            parentId: type._id,
            get: {
              url: process.env.API_BASE_URL + "/map-features",
              method: "get",
              params: {
                q: JSON.stringify({
                  eventType: type._id
                }),
                limit: 0
              },
              toGeoJson: data => {
                return {
                  type: "FeatureCollection",
                  features: data.results.map(item => {
                    let feature = item.feature;
                    feature.properties.id = item._id;
                    feature.properties.parentData = {
                      title: item.event.title,
                      url: `https://global.rescue-1.co.il/events/${item.event._id}`
                    }
                    return feature;
                  })
                };
              }
            },
            editable: false,
            overrideProperties: {
              markerType: "",
              glyph: type.icon,
              iconColor: type.color,
              color: "white"
            },
            defaultProperties: {
              markerType: "",
              iconColor: "white",
              color: "blue"
            },
            isActive
          });
        }
      }
      this.$store.commit("maps/APPEND_DATA_SOURCES_GROUPS", {
        mapId: this.mapId,
        val: [
          {
            title: "אירועים",
            dataSources
          }
        ]
      });
    },
    generateActiveEventsDataSources(isActive = false) {
      let dataSources = [];
      let eventTypes = Object.values(this.$store.state.entities.eventTypes);
      if (Array.isArray(eventTypes)) {
        for (let type of eventTypes) {
          dataSources.push({
            name: type.titlePlural,
            parentId: type._id,
            get: {
              url: process.env.API_BASE_URL + "/map-features",
              method: "get",
              params: {
                q: JSON.stringify({
                  eventType: type._id
                }),
                limit: 0
              },
              toGeoJson: data => {
                return {
                  type: "FeatureCollection",
                  features: data.results.filter(item => item.event.endDate === null).map(item => {
                    let feature = item.feature;
                    feature.properties.id = item._id;
                    feature.properties.parentData = {
                      title: item.event.title,
                      url: `https://global.rescue-1.co.il/events/${item.event._id}`
                    }
                    return feature;
                  })
                };
              }
            },
            editable: false,
            overrideProperties: {
              markerType: "",
              glyph: type.icon,
              iconColor: type.color,
              color: "white"
            },
            defaultProperties: {
              markerType: "",
              iconColor: "white",
              color: "blue"
            },
            isActive
          });
        }
      }
      this.$store.commit("maps/APPEND_DATA_SOURCES_GROUPS", {
        mapId: this.mapId,
        val: [
          {
            title: "אירועים פעילים",
            dataSources
          }
        ]
      });
    },
    generateOtherDataSources(isActive = false) {
      let dataSources = [
        {
          name: 'סיפורי דרך',
          get: {
            url: 'https://api.sipurderech.co.il/v1/trips',
            method: "get",
            params: {
              fieldsSet: 'light',
              limit: 10000
            },
            headers: {
              'X-Key': 'FCBB8CFD322A154AAFED594AD8ADD'
            },
            toGeoJson: data => {
              return {
                type: "FeatureCollection",
                features: data.results.map(item => {
                  let feature = {
                    geometry: {
                      type: "Point",
                      coordinates: [item.center.lng || 0, item.center.lat || 0]
                    },
                    properties: {},
                    type: "Feature"
                  };
                  feature.properties.id = 'sipurderech-' + item._id;
                  feature.properties.description = item.subtitle;
                  feature.properties.parentData = {
                    title: item.title,
                    url: `https://www.sipurderech.co.il/${item.slug}`
                  }
                  return feature;
                })
              };
            }
          },
          editable: false,
          overrideProperties: {
            markerType: "",
            glyph: "mdi-book",
            iconColor: "blue",
            color: 'white'
          },
          defaultProperties: {
            markerType: "",
            iconColor: "white",
            color: "blue"
          },
          isActive
        }
      ];
      this.$store.commit("maps/APPEND_DATA_SOURCES_GROUPS", {
        mapId: this.mapId,
        val: [
          {
            title: "שונות",
            dataSources
          }
        ]
      });
    },
    generateInreachLastPositionsDataSources(isActive = false) {
      console.log('generateInreachLastPositionsDataSources');
      let dataSources = [
        {
          name: 'כל המכשירים',
          get: {
            url: process.env.API_BASE_URL + '/sat/get-last-positions-for-active-devices',
            method: "get",
            params: {},
            toGeoJson: data => {
              return {
                type: "FeatureCollection",
                features: data.results.map(item => {
                  let feature = {
                    geometry: {
                      type: "Point",
                      coordinates: [item.point.longitude || 0, item.point.latitude || 0]
                    },
                    properties: {},
                    type: "Feature"
                  };
                  feature.properties.id = 'sipurderech-' + item._id;
                  feature.properties.type = 'INREACH_DEVICE';
                  feature.properties.title = item.imei;
                  feature.properties.description = format(item.timeStamp, 'DD/MM/YYYY HH:mm');
                  // feature.properties.parentData = {
                  //   title: item.title,
                  //   url: `https://www.sipurderech.co.il/${item.slug}`
                  // }
                  return feature;
                })
              };
            }
          },
          editable: false,
          overrideProperties: {
            markerType: "",
            glyph: "mdi-phone",
            iconColor: "blue",
            color: 'white'
          },
          defaultProperties: {
            markerType: "",
            iconColor: "white",
            color: "blue"
          },
          isActive
        }
      ];
      this.$store.commit("maps/APPEND_DATA_SOURCES_GROUPS", {
        mapId: this.mapId,
        val: [
          {
            title: "מכשירים לוויניים",
            dataSources
          }
        ]
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/mapContainerMixins.js